import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../utils/api';

const AccessModeContext = createContext({ eclipse: false, setEclipse: async () => {}, saving: false });

// Eclipse mode = admin kill-switch: Tellers are signed out, Front Desk sees only Calendar + Patients.
export const AccessModeProvider = ({ user, children }) => {
  const [eclipse, setEclipseState] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user) { setEclipseState(false); return undefined; }
    let alive = true;
    const pull = () => api.get('/access-mode').then((r) => alive && setEclipseState(!!r.data.eclipse)).catch(() => {});
    pull();
    const t = setInterval(pull, 30 * 1000);
    return () => { alive = false; clearInterval(t); };
  }, [user]);

  const setEclipse = useCallback(async (value) => {
    setSaving(true);
    try {
      await api.put('/admin/access-mode', { eclipse: value });
      setEclipseState(value);
      toast.success(value ? 'Eclipse ON — tellers signed out, front desk limited to Calendar & Patients' : 'Eclipse OFF — normal access restored');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not change access mode');
    } finally { setSaving(false); }
  }, []);

  return (
    <AccessModeContext.Provider value={{ eclipse, setEclipse, saving }}>
      {children}
    </AccessModeContext.Provider>
  );
};

export const useAccessMode = () => useContext(AccessModeContext);
